// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__QhqKV","title":"ClientReferral_title__16TZj","itemText":"ClientReferral_itemText__1AFpr"};